export const fecharFormAtual = (tabPanelItems, indexTabPanelMain, setIndexTabPanelMain, hideUpfPopupForm) => {
    
    if(hideUpfPopupForm){
        hideUpfPopupForm()
    }
    else{
        setIndexTabPanelMain(indexTabPanelMain - 1)
        tabPanelItems.splice(indexTabPanelMain, 1)
    }
}